<template>
    <div class="emailtemplate__list_grid_item">
        <form-notification
            :item="item"
            :name="item.name"
            :id="item.id"
            :identifier="item.identifier"
        />
    </div>
</template>

<script>
import FormNotification from '@/components/default/forms/FormNotification'
export default {
  name: 'emailtemplate-list-grid-item',
  components: { FormNotification },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
